import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, InputBase } from '@material-ui/core';
import { NumberListInput } from '../../store/inputs/NumberListInput';

const CNumberListInput = observer(({ item }: { item: NumberListInput }) => {
  const {
    label,
    value,
    selectorValue,
    placeholder,
    onChange,
    onChangeValue,
    disabled,
    error,
    tag,
    isKey,
    isEdit,
  } = item;
  const [numbers, setNumbers] = useState<number[]>([]);
  const [localSelector, setLocalSelector] = useState(selectorValue || '');

  useEffect(() => {
    setNumbers(value || []);
  }, [value]);

  useEffect(() => {
    setLocalSelector(selectorValue || '');
  }, [selectorValue]);

  const isLocked = disabled || (isKey && isEdit);

  const addNumber = () => {
    if (!localSelector) return;
    try {
      const newNumbers: number[] = [...numbers, parseFloat(localSelector as string)];
      onChangeValue(newNumbers);
      setLocalSelector('');
      onChange('');
    } catch {
      onChangeValue([]);
    }
  };

  const removeNumber = (nb: number) => {
    const idx = numbers.findIndex((n: number) => n === nb);
    if (idx >= 0) {
      const newNumbers = [...numbers];
      newNumbers.splice(idx, 1);
      onChangeValue(newNumbers);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={11} style={{ margin: '0 auto' }}>
        <div
          style={{
            border: error ? '1px solid #e53935' : '1px solid #e0e0e0',
            borderRadius: '10px',
            padding: '14px 16px',
            margin: '8px 0',
            background: isLocked ? '#fafafa' : '#fff',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <i
              className={isKey ? 'bx bx-key' : 'bx bx-list-ol'}
              style={{ fontSize: '15px', color: '#757575', marginRight: '6px' }}
            />
            <span style={{ fontSize: '12px', fontWeight: 500, color: '#757575', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
              {label}
            </span>
          </div>

          {!isLocked && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: numbers.length > 0 ? '10px' : '0' }}>
              <InputBase
                id={tag}
                type="number"
                value={localSelector}
                placeholder={placeholder || `Type a number...`}
                onChange={(e) => {
                  setLocalSelector(e.target.value);
                  onChange(e.target.value);
                }}
                onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addNumber(); } }}
                disabled={isLocked}
                style={{
                  flex: 1,
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  fontSize: '13px',
                  color: '#212121',
                  fontFamily: 'inherit',
                }}
              />
              <button
                onClick={() => addNumber()}
                disabled={!localSelector}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '38px',
                  height: '38px',
                  border: !localSelector ? '1px solid #e0e0e0' : '1px solid #1a73e8',
                  borderRadius: '8px',
                  background: !localSelector ? '#fafafa' : '#1a73e8',
                  color: !localSelector ? '#bdbdbd' : '#fff',
                  cursor: !localSelector ? 'default' : 'pointer',
                  flexShrink: 0,
                  outline: 'none',
                  transition: 'all 0.15s ease',
                }}
                title="Add"
              >
                <i className="bx bx-plus" style={{ fontSize: '18px' }} />
              </button>
            </div>
          )}

          {numbers.length > 0 ? (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {numbers.map((nb, index) => (
                <div
                  key={`${nb}${index}`}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '5px',
                    padding: '4px 8px 4px 10px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '20px',
                    background: '#fafafa',
                    fontSize: '12px',
                    color: '#424242',
                  }}
                >
                  <span>{nb}</span>
                  {!isLocked && (
                    <i
                      className="bx bx-x"
                      onClick={() => removeNumber(nb)}
                      style={{
                        fontSize: '15px',
                        color: '#bdbdbd',
                        cursor: 'pointer',
                        transition: 'color 0.15s ease',
                      }}
                      onMouseEnter={(e) => { (e.target as HTMLElement).style.color = '#e53935'; }}
                      onMouseLeave={(e) => { (e.target as HTMLElement).style.color = '#bdbdbd'; }}
                    />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <span style={{ fontSize: '12px', color: '#bdbdbd', fontStyle: 'italic' }}>No items added</span>
          )}

          {error && (
            <span style={{ fontSize: '11px', color: '#e53935', marginTop: '4px', display: 'block' }}>{error}</span>
          )}
        </div>
      </Grid>
    </Grid>
  );
});

export default CNumberListInput;
